import type { ChatGroupMember } from '@/contexts/chat/scripts/hooks/useChatGroup/types';
import { ChatMessagePayloadType } from '@/contexts/chat/scripts/hooks/useChatMessages/types';
import styles from './index.module.scss';

interface AddParticipantsModalProps {
  open: boolean;
  normalMemberList: ChatGroupMember[];
  onCancel: () => void;
  onCall: (payload: ChatMessagePayloadType, selectUsers: ChatGroupMember[]) => void;
}
const AddParticipantsModal = ({
  open,
  normalMemberList,
  onCancel,
  onCall,
}: AddParticipantsModalProps) => {
  const [selectUsers, setSelectUsers] = useState<ChatGroupMember[]>([]);
  const [searchText, setSearchText] = useState<string>('');

  const data_ = useMemo(() => {
    return normalMemberList?.filter((item) => item.name?.includes(searchText));
  }, [searchText, normalMemberList]);

  const handleSearch = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  }, []);

  const handleToggleUser = useCallback((item: ChatGroupMember) => {
    setSelectUsers((prev) =>
      prev.some((user) => user.user_id === item.user_id)
        ? prev.filter((user) => user.user_id !== item.user_id)
        : [...prev, item]
    );
  }, []);

  const handleSelectAll = () => {
    const normalMemberList_ = normalMemberList; // normalMemberList.filter((_, index) => index !== 1);
    if (selectUsers.length === normalMemberList_?.length) {
      setSelectUsers([]);
    } else {
      setSelectUsers(normalMemberList_ ?? []);
    }
  };

  return (
    <Modal
      zIndex={2001}
      width={440}
      title="Add participants"
      open={open}
      onCancel={onCancel}
      maskClosable={false}
      className={styles.groupMediaCreateCallModal}
      footer={null}
    >
      <Input
        className={styles.searchInput}
        value={searchText}
        prefix={<SearchOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
        variant="filled"
        placeholder="Search"
        onChange={handleSearch}
      />
      <div className={styles.selected}>
        {selectUsers.map((item) => {
          return <MyAvatar key={item.user_id} src={item.avatar} info={item}></MyAvatar>;
        })}
      </div>
      <div className={styles.content}>
        <div className={styles.title}>Recently chats</div>
        <div className={styles.list}>
          {data_?.map((item) => {
            return (
              <MemberItem
                key={item.user_id}
                name={item.name}
                avatarProps={{ src: item.avatar, info: item }}
                checked={!!selectUsers.find((user) => user.user_id === item.user_id)}
                //  disabled={index == 1}
                onClick={() => handleToggleUser(item)}
                extra={
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    Call
                  </Button>
                }
              />
            );
          })}
        </div>
      </div>
      <div className={styles.footer}>
        <div className={styles.selectAll} onClick={handleSelectAll}>
          <Checkbox
            className={styles.checkbox}
            checked={selectUsers.length === normalMemberList?.length}
          >
            Select all
          </Checkbox>
        </div>
        <Space size="middle">
          <Button onClick={onCancel}>Cancel</Button>
          <Button
            type="primary"
            onClick={() => onCall(ChatMessagePayloadType.MEDIA_VIDEO_CALL, selectUsers)}
          >
            {!!selectUsers.length && selectUsers.length} Call
          </Button>
        </Space>
      </div>
    </Modal>
  );
};

export default AddParticipantsModal;
